import { Injectable } from "@angular/core";
import { CustomMapBuilding } from "../models/customMapBuilding.model";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, of } from "rxjs";
import { ToastService } from "./toast.service";
import { GridService } from "../shared/grid/grid.service";

@Injectable({
    providedIn: "root",
})
export class CustomMapBuildingService extends GridService<CustomMapBuilding> {
    constructor(
        http: HttpClient,
        private toastService: ToastService,
    ) {
        super("CustomMapBuilding", http);
    }

    getAllMaps(orglevelId: string): Observable<CustomMapBuilding[]> {
        return this.http
            .get<
                CustomMapBuilding[]
            >(this.getApiUrl(`${this.controllerName}/GetAllMaps?organizationLevelId=${orglevelId}`))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading map buildings",
                        true,
                    );
                    return of([]);
                }),
            );
    }
}
